module.exports = __webpack_public_path__ + "static/media/LogicWheel6_1_drag_2.a9ecd74f.png";